import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "offline-block",
  "use": "offline-block-usage",
  "viewBox": "0 0 72 40",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 72 40\" id=\"offline-block\"><rect width=\"72\" height=\"40\" rx=\"2\" fill=\"#00AB44\" fill-opacity=\".4\" /><circle cx=\"23\" cy=\"21\" r=\"2\" fill=\"#fff\" /><circle cx=\"27\" cy=\"28\" r=\"2\" fill=\"#fff\" /><circle cx=\"28\" cy=\"14\" r=\"3\" fill=\"#fff\" /><circle cx=\"43\" cy=\"22\" r=\"4\" fill=\"#fff\" /><circle cx=\"38\" cy=\"13\" r=\"4\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol